import React, {Suspense, useCallback, useContext, useMemo, useState} from 'react';
import styled, {useTheme} from "styled-components";
import {MarginBox} from "../ui/styled";
import SllMatchItem from "./SllMatchItem";
import SliMatchInfo from "./SliMatchInfo";
import InfluIcon from "../summoner/Profile/InfluInfo/InfluIcon";
import {SllMatchContext} from "./sllMatchContext";
import ScoreWrapper from "../summoner/DetailTab/GameAnalytics/BestContent/BestSection/ScoreWrapper";
import useMvp from "../../common/hooks/sli/useMvp";
import {useTranslation} from "react-i18next";
import useMatchRating from "../../common/hooks/sli/useMatchRating";
import SllKda from "./sllKda";
import VenatusAd from "../ad/VenatusAd";
import SllTeamList from "./SllTeamList";
import {useSliApi} from "../../common/hooks/sli/useSliApi";
import SllMatchContent from "./sllMatchContent";
import {ImageLane, Loading} from "../common";
import {sllPosition} from "../../function";
import useMatchBackground from "../../common/hooks/sli/useMatchBackground";
import ToSummonerLink from "../Link/ToSummonerLink";
import SllOverview from "./SllOverview";
import SllNavigation from "./sllNavigation";

const Wrapper = styled.div`
  width: 100%;
`;
const SllContentBox = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 16px;
`;
const MatchContent = styled.div`
  width: 620px;
  margin-left: 16px;
`;
const SllContent = () => {
    const {list, query} = useSliApi({tournamentName: 'sll'});
    const [selectedTeamId, setSelectedTeamId] = useState(list.all_teams[0].team_id);
    const selectedTeam = useMemo(() => {
        try {
            const result = list.all_teams.find((data) => data.team_id === selectedTeamId)
            if (result.team_name) {
                return result;
            }
            return "error"
        } catch (e) {
            return "error"
        }
    }, [selectedTeamId, list.all_teams])


    return (
        <Wrapper>
            <SllNavigation/>
            <TitleBox

                data={list.best}
            />
            <SllContentBox>
                <SllTeamList list={list.all_teams} selectedTeamId={selectedTeamId}
                             setSelectedTeamId={setSelectedTeamId}/>
                <MatchContent>
                    <SllOverview list={list.tournament}/>
                    <Suspense fallback={<Loading/>}>
                        <SllMatchContent teamId={selectedTeamId} team={selectedTeam} key={selectedTeamId} tournamentName={'sll'}/>
                    </Suspense>
                </MatchContent>
            </SllContentBox>
        </Wrapper>
    );
};


const TitleBoxWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 230px;
  justify-content: space-between;
  padding-left: 16px;
  border-radius: 6px;
  border: 1px solid ${props => props.theme.color.default_border_color};
  background-color: ${props => props.theme.color.site_main_color};
`;
const Title = styled.span`
  font-weight: 600;
  font-size: 24px;
`;
const SubTitle = styled.span`
  font-size: 16px;
  font-weight: 600;
  color: ${props => props.theme.color.dark_200};
  line-height: 21px;
`;
const InfoBox = styled.div`
  width: 128px;
`;
const PlayerBox = styled.div`
  width: 106px;
`;

const ScoreBox = styled.div`
  width: 88px;
`;

const KdaBox = styled.div`
  width: 96px;
`;

const KdaWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 100%;
`;

const ToViewBox = styled.div`
  width: 214px;
  display: flex;
  height: 100%;
  align-items: center;
`;

const ViewButton = styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 160px;
  height: 32px;
  border-radius: 99px;
  padding: 9px 0;
  border: 1px solid ${props => props.theme.color.green_100};
  color: ${props => props.theme.color.green_100};
  background-color: ${props => props.theme.color.green_200};
  font-weight: 700;
  font-size: 12px;
  text-align: center;
`;

const VideoWrapper = styled.div`
  width: 410px;
  height: 230px;
  background-color: #D9D9D9;
`;
const ContentBox = styled.div`
  padding-top: 16px;
  padding-bottom: 12px;
`;

const TitleExtra = styled.span`
  font-weight: 500;
  font-size: 13px;
  color: ${props => props.theme.color.dark_300};
  margin-left: 8px;
`;

const TitleBox = ({data}) => {
    const [selectedLane, setSelectedLane] = useState('best')
    const theme = useTheme();
    const selectedData = useMemo(() => {
        try {
            return data[selectedLane]
        } catch (e) {
            return data.best
        }
    }, [data, selectedLane]);
    const {myMatch} = useMatchBackground({match: selectedData.match, targetPuuId: selectedData.puu_id});

    return (
        <TitleBoxWrapper>
            <ContentBox>
                <div>
                    <Title>
                        2025 SLL SUMMER<TitleExtra>(MVP 선정은 SLL 실제 경기 AI-Score만 집계됩니다.)</TitleExtra>
                    </Title>
                </div>
                <MarginBox margin={'4px 0 0 0'}>
                    <SubTitle>
                        딥롤 Ai Score로 보는 mvp는?
                    </SubTitle>
                </MarginBox>
                <MarginBox margin={'9px 0'}>
                    <MVPFilterList selectedLane={selectedLane} setSelectedLane={setSelectedLane}/>
                </MarginBox>
                <SllMatchItem match={selectedData.match} targetPuuId={selectedData.puu_id} data={selectedData}>
                    <InfoBox>
                        <SliMatchInfo title={'SLL 최고의 선수'}/>
                    </InfoBox>
                    <PlayerBox>
                        <PlayerInfo/>
                    </PlayerBox>
                    <ScoreBox>
                        <ScoreBoxInfo/>
                    </ScoreBox>
                    <KdaBox>
                        <KdaWrapper>
                            <SllKda/>
                        </KdaWrapper>
                    </KdaBox>
                    <ToViewBox>
                        <ToSummonerLink puu_id={selectedData.puu_id}
                                        name={`${myMatch?.riot_id_name}-${myMatch?.riot_id_tag_line}`}
                                        region={'KR'} extra={`matches/${selectedData?.match_id}`}>
                            <ViewButton onClick={() => {

                            }}>
                                MVP 경기 결과 보기
                                <img src={`${theme.icon.path}/navigate_next.svg`} alt={''}/>
                            </ViewButton>
                        </ToSummonerLink>
                    </ToViewBox>
                </SllMatchItem>
            </ContentBox>
            <VideoWrapper>
                <VenatusAd placementName={'video'}/>
            </VideoWrapper>
        </TitleBoxWrapper>
    )
}

const MVPFilterListWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`

const MVPFilterList = ({selectedLane, setSelectedLane}) => {
    const onClickItem = (value) => {
        setSelectedLane(value)
    }

    return (
        <MVPFilterListWrapper>
            <MVPFilterItem selected={selectedLane} value={'best'} onClick={onClickItem}>
                AI 종합 MVP 1위
            </MVPFilterItem>
            <MVPFilterItem selected={selectedLane} value={'TOP'} onClick={onClickItem}>
                탑 MVP
            </MVPFilterItem>
            <MVPFilterItem selected={selectedLane} value={'JUNGLE'} onClick={onClickItem}>
                정글 MVP
            </MVPFilterItem>
            <MVPFilterItem selected={selectedLane} value={'MIDDLE'} onClick={onClickItem}>
                미드 MVP
            </MVPFilterItem>
            <MVPFilterItem selected={selectedLane} value={'BOTTOM'} onClick={onClickItem}>
                바텀 MVP
            </MVPFilterItem>
            <MVPFilterItem selected={selectedLane} value={'UTILITY'} onClick={onClickItem}>
                서폿 MVP
            </MVPFilterItem>
        </MVPFilterListWrapper>
    )
}
const MVPFilterItemWrapper = styled.button`
  width: auto;
  padding: 3.5px 8px;
  color: ${props => props.theme.color.green_100};
  background-color: ${props => props.theme.color.green_200};
  border: 1px solid ${props => props.theme.color.gree_100};
  font-weight: 700;
  font-size: 14px;
  border-radius: 4px;
`;
const MVPFilterItemUnSelected = styled.button`
  padding: 3.5px 8px;
  font-weight: 700;
  font-size: 14px;
  color: ${props => props.theme.color.green_100};
  border: 1px solid transparent;
  opacity: 0.5;
  border-radius: 4px;

`;
const MVPFilterItem = ({value, children, onClick, selected}) => {
    if (selected !== value) {
        return (
            <MVPFilterItemUnSelected onClick={() => onClick(value)}>
                {children}
            </MVPFilterItemUnSelected>
        )
    }
    return (
        <MVPFilterItemWrapper>
            {children}
        </MVPFilterItemWrapper>
    )
}

const PlayerInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 8px 10px;
`;
const PlayerName = styled.span`
  color: ${props => props.theme.color.dark_100};
  margin-left: 8px;
  max-width: 60px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
const InfluWrapper = styled.div`
  margin-top: 10px;
  display: flex;
  flex-direction: row;
  border-radius: 6px;
  padding: 5px 8px;
  background-color: ${props => {
    let color = props.theme.color.red_1000;
    if (props.status) {
      color = props.theme.color.blue_500
    }
    return color
  }};`;
const PlayerImage = styled.img`
  border-radius: 4px;
  object-fit: cover;
`;

const RelativeWrapper = styled.div`
  position: relative;
  border-radius: 4px;
  background-color: ${props => {
    let color = 'rgba(103, 42, 42, 0.15)'
    if (props.status) {
      color = 'rgba(4, 138, 255, 0.15)'
    }
    return color
  }};
`;
const LaneBox = styled.div`
  position: absolute;
  right: 0;
  bottom: 0;
  width: 20px;
  height: 20px;
  background-color: rgba(0, 0, 0, 0.8);

  .imgLane {
    width: 20px;
    height: 20px;
  }
`;
const PlayerInfo = () => {
    const {data, myMatch} = useContext(SllMatchContext);

    return (
        <PlayerInfoWrapper>
            <RelativeWrapper status={data?.is_win}>
                <PlayerImage
                    src={`https://ak-deeplol-ddragon-cdn.deeplol.gg/${data.status.toLowerCase()}/${data.status === 'pro' ? data.championship_name : data.name}.png`}
                    width={52} height={52}
                    onError={(e) => e.target.src = '/images/sll/sll_empty_profile.svg'}
                    alt={''}/>
                <LaneBox>
                    <ImageLane
                        lane={sllPosition(data.position)}
                    />
                </LaneBox>
            </RelativeWrapper>
            <InfluWrapper status={data?.is_win}>
                <InfluIcon status={data.status}/>
                <PlayerName>
                    {data.status === 'pro' ? data.championship_name : data.name}
                </PlayerName>
            </InfluWrapper>
        </PlayerInfoWrapper>
    )
}

const ScoreText = styled.span`
  margin-bottom: 5px;
  font-weight: 400;
  font-size: 12px;
  color: ${props => props.theme.color.dark_100};
`;

const MVPBox = styled.div`
  margin-top: 5px;
  display: flex;
  flex-direction: row;
  align-items: center;


  .MVP {
    color: #F3A634;
    font-weight: 700;
  }

  .ACE {
    font-weight: 700;
    color: #8e9ec4;
  }
`;

const CrownMvp = styled.span`
  display: flex;
  background-image: url('/images/ico_best_player01.svg');
  width: 16px;
  height: 16px;
  margin-right: 5px;
  margin-top: 2px;
  content: '';
`;

// noinspection CssUnknownTarget
const CrownAce = styled.span`
  display: flex;
  background-image: url('/images/ico_best_player04.svg');
  width: 16px;
  height: 16px;
  margin-right: 5px;
  margin-top: 2px;
  content: '';
`;
const AwayText = styled.span`
  opacity: 1;
  color: ${props => props.theme.color.red_300};
`;
const ScoreBoxInfoWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px 0;
`;
const ScoreBoxInfo = () => {
    const {myMatch, match, data} = useContext(SllMatchContext);
    const {getMvp} = useMvp({myMatch, match});
    const {getRank} = useMatchRating({match, myMatch});
    const {t} = useTranslation();

    const RatingRender = useCallback(({match, rating}) => {
        if (!match?.is_runaway) {
            if (getMvp) {
                const specialChar = match?.is_win ? 'MVP' : 'ACE';
                return <span className={specialChar}>{specialChar}</span>
            }
            return (<>
                <i>{rating}</i>{t('summoner.grade', {count: rating, ordinal: true})}
            </>)
        }

        return (<AwayText>{t("tags.escape")}</AwayText>)

    }, [getMvp])

    return (
        <ScoreBoxInfoWrapper>
            <ScoreText>
                AI-Score
            </ScoreText>
            <ScoreWrapper
                paddingVertical={3}
                paddingHorizontal={7}
                score={data.ai_score}
                fontSize={20}
            />
            <MVPBox>
                {myMatch?.is_win ? (getMvp && <CrownMvp/>) : (getMvp && <CrownAce/>)}
                <RatingRender match={myMatch} rating={getRank}/>
            </MVPBox>
        </ScoreBoxInfoWrapper>
    )
}

export default SllContent;